import React from 'react'
import PropTypes from 'prop-types'
import ReactSelect, { components } from 'react-select'
import find from 'lodash/find'
import isEmpty from 'lodash/isEmpty'
import { AngleDown } from 'styled-icons/fa-solid/AngleDown'
import { Times } from 'styled-icons/fa-solid/Times'
import { utils } from '../../lib'

const DropdownIndicator = props => components.DropdownIndicator && (
    <components.DropdownIndicator {...props}>
      <AngleDown size={12} />
    </components.DropdownIndicator>
)
const ClearIndicator = props => components.ClearIndicator && (
    <components.ClearIndicator {...props}>
      <Times size={12} />
    </components.ClearIndicator>
)

const controlNormal = base => ({ ...base, backgroundColor: 'hsl(0, 0%, 100%)', minWidth: '160px', minHeight: '34px', boxShadow: 'none' })
const controlSmall = base => ({ ...base, backgroundColor: 'hsl(0, 0%, 100%)', minWidth: '160px', minHeight: '30px', boxShadow: 'none' })
const optionNormal = base => base
const optionNarrow = base => ({ ...base, padding: '0 12px' })
const valueNormal = base => base
const valueSmall = base => ({ ...base, padding: '0 8px' })
const menu = base => ({ ...base, marginTop: '0', zIndex: 5 })
const group = base => ({ ...base, paddingTop: '0' })
const groupHeading = base => ({ ...base, color: 'red' })


class Select extends React.Component {
  constructor(...args) {
    super(...args)
    this.state = {
      options: this.props.options,
      selection: this.value2options(this.props)
    }
  }

  componentWillReceiveProps = props => this.setState({ options: props.options, selection: this.value2options(props) })
  onChange = v => this.props.isMulti  //Array.isArray(v)
    ? this.props.onChange(isEmpty(v) ? [] : v.map(o => o.value) )
    : this.props.onChange(isEmpty(v) ? '' : v.value)

  value2options = props => {
    const { options, value } = props
    if (!value) return null
    if (Array.isArray(value)) {
      return value.map(v => find(options, {value: v}))
    } else {
      return find(options, {value: value})
    }
  }

  render() {
    const { options, selection } = this.state
    const { small, narrow } = this.props

    const customStyles = {
      control: small ? controlSmall : controlNormal,
      valueContainer: small ? valueSmall : valueNormal,
      option: narrow ? optionNarrow : optionNormal,
      menu: menu,
      group: group,
      groupHeading: groupHeading
    }

    const filteredProps = utils.filter(this.props, { options: true, value: true, small: true, narrow: true })

    return (
      <ReactSelect {...filteredProps}
        components={{ ClearIndicator, DropdownIndicator }}
        styles={customStyles}
        options={options}
        value={selection}
        onChange={this.onChange}
      />
    )
  }
}

Select.defaultProps = {
  small: false,
  narrow: false,
  onChange: () => {},
}

Select.propsTypes = {
  small: PropTypes.bool,
  narrow: PropTypes.bool,
  onChange: PropTypes.func,
}

export default Select



// WEBPACK FOOTER //
// ./src/components/widgets/Select.js